<template>
  <div class="content">
    <title-bar :title="$lang.bonus_title2"></title-bar>
    <div class="content-c" style="padding: 3%">
      <!-- <div>
        <img
          src="../../../assets/img/bonus/bonus3.png"
          width="100%"
          style="border-radius: 13px"
        />
      </div> -->
      <!-- <div style="position: relative">
        <img
          src="../../../assets/img/bonus/bonus3.png"
          width="100%"
          style="border-radius: 13px"
        />
        <div style="position: absolute; top: 20px; left: 20px">
          <p
            style="font-weight: 800; font-size: var(--vk-fs-15); margin-bottom: 10px"
            v-html="$lang.common_txt238"
          ></p>
          <p v-html="$lang.common_txt239"></p>
        </div>
      </div> -->
      <div class="content-a m-t-10">
        <div v-safe-html.rich="activityRuleHtml" class="content-b"></div>
        <div v-if="readError" class="read-error">{{ readError }}</div>
        <van-button @click="goToRec" size="large" class="custom-button m-t-20">
          {{ $lang.bonus_txt4 }}
        </van-button>
        <login v-model="showPopup" overlay></login>
        <div class="m-b-20 info-color m-t-5">
          {{ $lang.bonus_txt5 }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GetPromoRule } from '@/api/common'
import { isReadableOkResponse, responseFailMessage, safeArray, safeContent, safeObject, safeString } from '@/views/layout/safeLayout'

const ACTIVITY_RULE_LIST_KEYS = ['promoRuleList', 'ruleList', 'activityList', 'list', 'dataList', 'records', 'items']
const ACTIVITY_RULE_ENVELOPE_KEYS = ['content', 'payload', 'extra', 'page', 'data', 'body']
const ACTIVITY_RULE_FIELD_KEYS = ['promoRules', 'promo_rules', 'ruleContent', 'rule_content', 'rules', 'description', 'descr', 'content', 'detail', 'details', 'remark', 'remarks']
const ACTIVITY_RULE_READ_ERROR = '活动规则读取失败，已保留默认文案。'
const ACTIVITY_RULE_MAX_DEPTH = 12
const ACTIVITY_RULE_KEYS = ['first recharge', 'first deposit', 'deposit bonus', '首充', '首次充值']

function scrollWindowTop() {
  try {
    if (typeof window !== 'undefined' && window && typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0)
    }
  } catch (e) {
    // Ignore scroll failures in restricted browser shells.
  }
}

function collectActivityRules(source, depth = 0, out = [], seen = new Set()) {
  if (!source || typeof source !== 'object' || depth >= ACTIVITY_RULE_MAX_DEPTH || seen.has(source)) return out
  seen.add(source)
  for (const key of ACTIVITY_RULE_LIST_KEYS) {
    safeArray(source[key]).forEach(rule => out.push(rule))
  }
  for (const key of ACTIVITY_RULE_ENVELOPE_KEYS) {
    const value = source[key]
    if (!value || typeof value !== 'object') continue
    collectActivityRules(value, depth + 1, out, seen)
  }
  return out
}

function activityRuleText(rule) {
  const item = safeObject(rule)
  for (const key of ACTIVITY_RULE_FIELD_KEYS) {
    const value = safeString(item[key]).trim()
    if (value) return value
  }
  return ''
}

function matchesActivityRule(rule) {
  const item = safeObject(rule)
  const text = [
    item.activityType,
    item.activity_type,
    item.actTypeKey,
    item.act_type_key,
    item.promoType,
    item.promo_type,
    item.promoDetail,
    item.promo_detail,
    item.type,
    item.code,
    item.ruleCode,
    item.rule_code,
    item.name,
    item.title,
    item.descr,
    item.description
  ].map(safeString).join(' ').toLowerCase()
  return ACTIVITY_RULE_KEYS.some(key => text.includes(key))
}

export default {
  name: 'ActivityFistRecharge',
  components: {},
  data() {
    return {
      activityRuleHtml: this.$lang.bonus_txt3,
      readError: '',
      showPopup: false
    }
  },
  mounted() {
    this.loadActivityRule()
  },
  methods: {
    async loadActivityRule() {
      try {
        const data = await GetPromoRule()
        if (!isReadableOkResponse(data)) {
          this.readError = responseFailMessage(data, ACTIVITY_RULE_READ_ERROR)
          return
        }
        const rule = collectActivityRules(safeContent(data)).find(matchesActivityRule)
        const ruleHtml = activityRuleText(rule)
        if (ruleHtml) {
          this.activityRuleHtml = ruleHtml
          this.readError = ''
        }
      } catch (error) {
        this.readError = responseFailMessage(error, ACTIVITY_RULE_READ_ERROR)
      }
    },
    requireLogin() {
      this.showPopup = true
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    goToRec() {
      if (!this.token) {
        this.requireLogin()
      } else {
        this.$jumpTo('/rechargeCont')
      }
      scrollWindowTop()
    }
  }
}
</script>
<style lang="less" scoped>
.content-b {
  font-size: var(--vk-fs-sm);
  border-radius: 12px;
  width: 100%;
  line-height: 16px;
  background: @cont-bg;
  padding: 3%;
}
.read-error {
  margin-top: 8px;
  color: #f56c6c;
  font-size: var(--vk-fs-xs);
  line-height: 16px;
}
</style>
